<template>
    <div class="products-school-page" style="background: #F2F2F2;">
        <div class="header-title" style="margin-top:50px;font-size: 30px;font-weight: bold;background: #FFFFFF">智慧校园服务内容</div>

        <div class="round-block">
            <el-col :xs="1" :sm="1" :md="2" :lg="4" :xl="4">&nbsp;</el-col>
            <el-col class="round-body" :xs="22" :sm="22" :md="20" :lg="16" :xl="16">

                <div class="round-item" v-for="item in roundList">
                    <img :src="item.image"/>
                    <div class="mark"></div>
                    <div class="name">{{item.name}}</div>
                </div>
            </el-col>
            <el-col :xs="1" :sm="1" :md="2" :lg="4" :xl="4">&nbsp;</el-col>
        </div>
        <div class="solution-row-block info-bg">
            <el-col :xs="1" :sm="1" :md="2" :lg="4" :xl="4">&nbsp;</el-col>
            <el-col class="info-body" :xs="22" :sm="22" :md="20" :lg="16" :xl="16">
                <div class="info-content">
                    一张网多应用，建网成本低，无需重复投资；建立统一数据平台和应用管理平台，仅通过少量物联网网关实现校园室内深度覆盖，并通过云端的多业务统一MSP平台，
                    实现多个不同应用终端的远程接入。智慧校园的应用场景主要主要功能包含以下：
                </div>
                <div class="school-info-point">
                    <li v-for="item in schoolInfoPoint">{{item}}</li>
                </div>
            </el-col>
            <el-col :xs="1" :sm="1" :md="2" :lg="4" :xl="4">&nbsp;</el-col>
        </div>
        <div class="solution-row-block image-bg">
            <el-col :xs="1" :sm="1" :md="2" :lg="4" :xl="4">&nbsp;</el-col>
            <el-col class="image-body" :xs="22" :sm="22" :md="20" :lg="16" :xl="16">
                <img v-for="item in schoolImgList" :src="item"/>
            </el-col>
            <el-col :xs="1" :sm="1" :md="2" :lg="4" :xl="4">&nbsp;</el-col>
        </div>
    </div>
</template>

<script>
    import RoundImage1 from '../../../../../views/image/common/solution_round_one.png'
    import RoundImage2 from '../../../../../views/image/common/solution_round_two.png'
    import RoundImage3 from '../../../../../views/image/common/solution_round_three.png'
    import RoundImage4 from '../../../../../views/image/common/solution_round_four.png'
    import InfoBg from '../../../../../views/image/common/solution_block_bg.png'
    import SchoolInfo1 from '../../../../../views/image/common/solution_info1.png'
    import SchoolInfo2 from '../../../../../views/image/common/solution_info2.png'
    import SchoolInfo3 from '../../../../../views/image/common/solution_info3.png'
    export default {
        name: "products-school-page",
        data(){
            return{
                infoBg:InfoBg,
                roundList:[
                    {name:'校园安全防范管理',image:RoundImage1},
                    {name:'校园能源环境',image:RoundImage2},
                    {name:'校园综合管理',image:RoundImage3},
                    {name:'物联网实训管理',image:RoundImage4},
                ],
                schoolInfoPoint:[
                    '消防穿透管理（烟雾告警、电气火灾预警、消防水压监测等）',
                    '资产管理（资产定位、资产信息溯源、电子围栏等）',
                    '车辆管理（无人值守道、车位占用情况、禁停区域管理等）',
                    '室内外环境监控（光照度监测、温湿度监测、空气质量监测）',
                    '能耗管理（远程智能抄表、能耗异常告警）',
                    '环卫管理（公厕卫生监测、垃圾桶监测、窨井监测）',
                    '园区定位管理（室内定位、大范围室外定位）',
                    '智慧教室（窗帘、门锁、空调、投影、照明系统、风扇等集中远程控制）',
                    '物联网实训（物联网体验中心、物联网实训套件）'
                ],
                schoolImgList:[
                    SchoolInfo1,SchoolInfo2,SchoolInfo3
                ]
            }
        },
    }
</script>

<style lang="scss" src="./products-school-page.scss" scoped>

</style>
